<app-navbar [title]="'Lead: ' + data.name">
	<!-- <button
		class="btn btn-warning me-3"
		*ngIf="pageFunction === 'edit' && !editable"
		(click)="deleteAsk()"
	>
		Usuń
	</button> -->
	<button
		class="btn btn-primary me-3"
		*ngIf="(pageFunction === 'edit' && editable) || pageFunction === 'add'"
		(click)="submit()"
	>
		Zapisz
	</button>
	<button class="btn btn-primary me-3" *ngIf="pageFunction === 'edit' && !editable" (click)="editUnlock()">
		Edycja
	</button>
	<a routerLink="/tourism-calendar/" class="btn btn-danger"> <i class="far fa-calendar-alt"></i> Kalendarz </a>
</app-navbar>

<div id="loader" *ngIf="loader">
	<span class="spinner-border spinner-grow-lg"></span>
</div>

<div class="container my-4">
	<div class="row">
		<div class="col">
			<form (submit)="submit()">
				<fieldset [disabled]="pageFunction !== 'add' && !editable">
					<div class="form-floating mb-3">
						<input type="text" class="form-control" name="name" id="name" [(ngModel)]="data.name" />
						<label for="name">Nazwa wydarzenia</label>
					</div>
					<div class="row mb-3">
						<div class="col-6">
							<div class="form-floating">
								<input
									type="datetime-local"
									class="form-control"
									name="date_from"
									id="date_from"
									[ngModel]="data.date_from | date: 'yyyy-MM-ddTHH:mm'"
									(ngModelChange)="data.date_from = $event"
									[ngClass]="{ error: this.errors.date_from }"
								/>
								<label for="date_from">Data rozpoczęcia</label>
							</div>
						</div>
						<div class="col-6">
							<div class="form-floating">
								<input
									type="datetime-local"
									class="form-control"
									name="date_to"
									id="date_to"
									[ngModel]="data.date_to | date: 'yyyy-MM-ddTHH:mm'"
									(ngModelChange)="data.date_to = $event"
									[ngClass]="{ error: this.errors.date_to }"
								/>
								<label for="date_to">Data zakończenia</label>
							</div>
						</div>
					</div>
					<div class="form-floating mb-3">
						<input
							type="text"
							class="form-control"
							name="client_representative"
							id="client_representative"
							[(ngModel)]="data.client_representative"
						/>
						<label for="client_representative">Klient - przedstawiciel na miejscu</label>
					</div>
					<div class="form-floating mb-3">
						<select class="form-control" name="leadSource" id="leadSource" [(ngModel)]="data.leadSource">
							<option [value]="obj.id" *ngFor="let obj of parameters.sources">
								{{ obj.name }}
							</option>
						</select>
						<label for="leadSource">Żródło</label>
					</div>
					<div class="form-floating mb-3">
						<app-tourism-events-vehicle-add
							[min]="data.date_from"
							[max]="data.date_to"
							[vehicles]="parameters.vehicles"
							[editable]="editable"
							[alreadyAddedVehicles]="data.vehicles"
							(emitVehiclesArray)="setVehicles($event)"
						></app-tourism-events-vehicle-add>
					</div>
					<div class="form-floating mb-3">
						<input
							type="number"
							step="1"
							min="0"
							class="form-control"
							id="people"
							name="people"
							[(ngModel)]="data.people"
						/>
						<label for="people">Planowana ilość osób</label>
					</div>
					<div class="form-floating mb-3">
						<textarea
							class="form-control"
							name="text_program"
							id="text_program"
							[(ngModel)]="data.text_program"
						></textarea>
						<label for="text_program">Program wyjazdu</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="text"
							class="form-control"
							name="calculation_link"
							id="calculation_link"
							[(ngModel)]="data.calculation_link"
						/>
						<label for="calculation_link">Link do kalkulacji</label>
					</div>
					<div class="form-floating mb-3">
						<textarea class="form-control" name="note" id="note" [(ngModel)]="data.note"></textarea>
						<label for="note">Notatka</label>
					</div>
					<div class="form-floating mb-3">
						<select class="form-control" name="status" id="status" [(ngModel)]="data.status">
							<option [value]="obj.id" *ngFor="let obj of parameters.statuses">
								{{ obj.name }}
							</option>
						</select>
						<label for="status">Status</label>
					</div>
				</fieldset>
			</form>
		</div>
		<div class="col-6" *ngIf="data.id">
			<div class="mb-4">
				<app-tags
					[leadId]="data.id"
					[tags]="tags"
					[tagsList]="parameters.tagsList"
					(added)="tagAdd($event)"
					(deleted)="tagDel($event)"
				></app-tags>
			</div>
			<app-php-tasks objType="tourismEvent" [objId]="data.id"></app-php-tasks>
		</div>
	</div>
</div>
